import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { makeGetCurrentUser } from '../selectors/users';
import { makeGetSortedActiveProjectTaskGroups } from '../selectors/task-groups';

import Layout from 'ui-kit/Layout';

import Popout from './popout';
import ResourceRepeatForm from 'components/ResourceRepeatForm';

import IconClose from 'icons/icon-close';

const ResourceRepeatPopout = ({ resourceType, projectId, rule, defaultFields, xAlign, defaultXPosition, autoShow, inline, title, onShow, onHide, onDisable, onCancel, onChange, children }) => {
    const { t } = useTranslation(['recurring', 'common']);
    const popoutCtrl = useRef(null);
    const [popoutVisible, setPopoutVisible] = useState(false);
    const [advancedVisible, setAdvancedVisible] = useState(false);
    const [ruleState, setRuleState] = useState(rule);

    const handlePopoutOpenClick = () => {
        popoutCtrl.current?.show();
    }

    const handlePopoutCloseClick = () => {
        popoutCtrl.current?.hide();
    }

    const handlePopoutShow = () => {
        setPopoutVisible(true);

        onShow?.();
    }

    const handlePopoutHide = () => {
        setPopoutVisible(false);

        onHide?.();
    }

    const handleDeleteClick = () => {
        onDisable?.();

        popoutCtrl.current?.hide();
    }

    const handleAdvancedToggle = () => {
        setAdvancedVisible(prevState => !prevState);
    }

    const handleSubmit = () => {
        const ruleProps = {
            type: ruleState.type,
            options: ruleState.options,
            fields: ruleState.fields,
            trigger: null,
            schedule: null,
            till: null
        };

        if (ruleState.type === 'date') {
            onChange({
                ...ruleProps,
                schedule: ruleState.schedule,
                till: ruleState.till
            });
        } else {
            onChange({
                ...ruleProps,
                trigger: ruleState.type === 'status' ? ruleState.trigger : undefined
            });
        }

        popoutCtrl.current?.hide();
    }

    const handleCancel = () => {
        popoutCtrl.current?.hide();

        onCancel?.();
    }

    // TODO: Add content loader
    const childrenWithProps = React.Children.map(children, child => {
        return React.cloneElement(child, {
            className: child.props.className + (popoutVisible ? ' selected disable-tooltip' : '')
        });
    });

    return (
        <>
            <div onClick={handlePopoutOpenClick}>
                { childrenWithProps }
            </div>

            <Popout
                className="no-arrow auto-size"
                provideController={popoutCtrl}
                onShow={handlePopoutShow}
                onHide={handlePopoutHide}
                xAlign={xAlign}
                defaultXPosition={defaultXPosition}
                closeOnEveryClick={true}
                visible={autoShow}
                inline={inline}
            >
                {
                    title ? (
                        <div className="popout-head">
                            { title }

                            <button className="btn btn-icon btn-small popout-close" onClick={handlePopoutCloseClick}>
                                <IconClose />
                            </button>
                        </div>
                    ) : null
                }

                <div className="popout-main">
                    <Layout level={3} style={{ padding: '5px 10px' }}>
                        <ResourceRepeatForm
                            resourceType={resourceType}
                            projectId={projectId}
                            rule={rule}
                            defaultFields={defaultFields}
                            advancedVisible={advancedVisible}
                            onChange={setRuleState}
                        />
                    </Layout>
                </div>

                <div className="popout-foot">
                    <div>
                        <button className="btn btn-link btn-colored" onClick={handleAdvancedToggle}>{ advancedVisible ? t('toggleAdvanced.hide') : t('toggleAdvanced.show') }</button>

                        {
                            onDisable ? (
                                <>
                                    <br />

                                    <span className="action" onClick={handleDeleteClick}>{ t('remove.title') }</span>
                                </>
                            ) : null
                        }
                    </div>

                    <div className="popout-actions">
                        <button className="btn btn-secondary btn-small" onClick={handleCancel}>{ t('common:Cancel') }</button>

                        <button className="btn btn-success btn-small" onClick={handleSubmit}>
                            { t('Set recurring') }
                        </button>
                    </div>
                </div>
            </Popout>
        </>
    );
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();
    const getSortedActiveProjectTaskGroups = makeGetSortedActiveProjectTaskGroups();

    return ({ users, taskGroups }, ownProps) => {

        return {
            currentUser: getCurrentUser(users),
            taskGroups: ownProps.projectId ? getSortedActiveProjectTaskGroups(taskGroups.items, ownProps.projectId) : []
        }
    }
}

export default connect(makeMapStateToProps)(ResourceRepeatPopout);